import React, { useContext, useRef } from "react";
import { PortalContext } from "../../../../context/Provider";
import credenciales from "../../../Genericos/MapaGoogle/credenciales";
import CardCentros from "../CardCentros";
import "./Clinicamedica.css";
import "../../../../pages/AtencionSinTurno/AtencionSinTurno.css";
import MapClinicaMedica from "../../../Genericos/MapaGoogle/MapClinicaMedica";

const Clinicamedica = () => {
  const trackButton = useRef();

  const { atencionSinTurnoState } =
    useContext(PortalContext);

  const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credenciales.mapsKey}`;
  const centrosClinica = Array.isArray(atencionSinTurnoState.atencionSinTurno.data)
    ? atencionSinTurnoState.atencionSinTurno.data.filter(
        (item) => item.tipoTexto === "Centros Clinica Med."
      )
    : [];

  return (
    <div className="ptur-atencionSinTurno-card-mapa" ref={trackButton}>
      <div className="ptur-atencionSinTurno-cuerpoCard">
        {Array.isArray(atencionSinTurnoState.atencionSinTurno.data) &&
          atencionSinTurnoState.atencionSinTurno.data.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <div className="ptur-atencionSinTurno-datosCard">
                  {item.tipoTexto === "Centros Clinica Med." ? (
                    <CardCentros
                      centro={item.centro}
                      ubicacion={item.ubicacion}
                      texto={item.texto.descripcion}
                      tipoTexto={item.tipoTexto}
                      idtipotexto={item.texto.idtipotexto}
                      coordenadaGps={item.coordenadaGps}
                    />
                  ) : (
                    <div
                      className="ptur-atencionSinTurno-cuerpoCard"
                      style={{ display: "unset" }}
                    ></div>
                  )}
                </div>
              </React.Fragment>
            );
          })}
      </div>
      <div className="ptur-atencionSinTurno-mapa">
        <MapClinicaMedica
          centros={centrosClinica}
          googleMapURL={mapURL}
          containerElement={<div style={{ height: "445px", width: "347px" }} />}
          mapElement={
            <div
              style={{
                height: "100%",
                border: "1px solid #E6E6E6",
                borderRadius: "16px",
              }}
            />
          }
          loadingElement={<p>Cargando</p>}
        />
      </div>
    </div>
  );
};

export default Clinicamedica;
